export function cardNumberFilter (cardNumber) {
  return cardNumber ? cardNumber.replace(/\*+/g, ' **** **** ') : ''
}
